export default [
  {
    name: 'Canarias Raster',
    description: 'Map with raster data situated on Canary Islands',
    mapType: 'ias',
    layersOverlayed: false,
    selectedButtons: {
      Title: false,
      Zoom: true,
      Attribution: false,
      Home: true,
      Search: false,
      Scale: true,
      BaseMapSelector: false,
      LayerSelector: true,
      Legend: false,
      QRCode: true
    },
    layers: ['Canarias Raster TMS', 'Canarias Vector Layer TMS'],
    baseMaps: ['OpenTopoMap', 'Stamen.TonerLite'],
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    }
  },
  {
    name: 'Canarias Raster Overlayed',
    description: 'Map with raster data situated on Canary Islands',
    mapType: 'ias',
    layersOverlayed: true,
    selectedButtons: {
      Title: true,
      Zoom: false,
      Attribution: true,
      Home: false,
      Search: true,
      Scale: false,
      BaseMapSelector: true,
      LayerSelector: false,
      Legend: true,
      QRCode: true
    },
    layers: ['Canarias Raster TMS', 'Canarias Vector Layer TMS'],
    baseMaps: ['OpenTopoMap', 'Stamen.TonerLite'],
    pageUrl: 'https://gitmoji.carloscuesta.me/',
    logoUrl:
      'https://cdn.enviaya.com.mx/assets/facebook-icon-a216f23742d810be2dd556c20cdab171942f5e502f4b13a39417a1230d5568b1.ico',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    }
  },
  {
    name: 'Canarias Raster SRM logo',
    description: 'Map with raster data situated on Canary Islands',
    mapType: 'ias',
    layersOverlayed: true,
    selectedButtons: {
      Title: true,
      Zoom: false,
      Attribution: true,
      Home: false,
      Search: true,
      Scale: false,
      BaseMapSelector: false,
      LayerSelector: false,
      Legend: false,
      QRCode: true
    },
    layers: ['Canarias Raster TMS', 'Canarias Vector Layer TMS'],
    baseMaps: ['OpenTopoMap', 'Stamen.TonerLite'],
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    }
  },
  {
    name: 'Servicios de Limpieza Madrid',
    description: 'Map with gargabe collection data for Madrid',
    layersOverlayed: false,
    mapType: 'ias',
    selectedButtons: {
      Title: true,
      Zoom: true,
      Attribution: true,
      Home: true,
      Search: true,
      Scale: true,
      BaseMapSelector: true,
      LayerSelector: true,
      Legend: true,
      QRCode: true
    },
    layers: [
      'Limpieza por Distritos 2018',
      'Limpieza por Distritos 2017',
      'Incremento Recogida',
      'Servicios Limpieza 2018',
      'Servicios Limpieza 2017',
      'Incremento Servicios'
    ],
    baseMaps: ['OpenStreetMap.Mapnik', 'Esri.Imagery'],
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.6699954899037, 40.476922686649474]
      },
      properties: {
        zoom: 11
      }
    }
  },
  {
    name: 'Servicios de Limpieza Madrid No Legend Transparency',
    description: 'Map with gargabe collection data for Madrid',
    layersOverlayed: false,
    mapType: 'ias',
    selectedButtons: {
      Title: true,
      Zoom: true,
      Attribution: true,
      Home: true,
      Search: true,
      Scale: true,
      BaseMapSelector: true,
      LayerSelector: true,
      Legend: false,
      QRCode: true
    },
    layers: [
      'Limpieza por Distritos 2018',
      'Limpieza por Distritos 2017',
      'Incremento Recogida',
      'Servicios Limpieza 2018',
      'Servicios Limpieza 2017',
      'Incremento Servicios'
    ],
    baseMaps: ['OpenStreetMap.Mapnik', 'Esri.Imagery'],
    layersTransparency: [
      { id: 'Limpieza por Distritos 2018', value: 1 },
      { id: 'Limpieza por Distritos 2017', value: 0.8 },
      { id: 'Incremento Recogida', value: 0 }
    ],
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.6699954899037, 40.476922686649474]
      },
      properties: {
        zoom: 11
      }
    }
  }
];
